import clsx from 'clsx';
import { useState } from 'react';
import { useTranslations } from 'next-intl';
import Input from '@/components/Input/Input';
import IngredientAccordion from './IngredientAccordion';
import styles from './Ingredients.module.scss';

export type FilterOption = { value: string; label: string };

type FiltersProps = {
  options: FilterOption[];
  selected: string[];
  onToggle: (value: string) => void;
  isMobile?: boolean;
  clearFilters: () => void;
};

const Filters: React.FC<FiltersProps> = ({
  options, selected, onToggle, isMobile = false,
}) => {
  const [openFilters, setOpenFilters] = useState(false);
  const t = useTranslations('ingredients');
  const allSelected = selected.length === options.length;

  const renderFilters = (showTitle = true) => (
    <ul className={styles.filtersList}>
      {showTitle && (
        <li>
          <p className={styles.filterTitle}>{t('Filters')}</p>
        </li>
      )}
      <li>
        <Input
          id='all'
          label={t('All Ingredients')}
          type='checkbox'
          checked={allSelected}
          onChange={() => onToggle('all')}
        />
      </li>
      {options.map((option) => (
        <li key={option.value}>
          <Input
            id={option.value}
            label={option.label}
            type='checkbox'
            checked={selected.includes(option.value)}
            onChange={() => onToggle(option.value)}
          />
        </li>
      ))}
      {/* {selected.length > 0 && (
        <li>
          <Button
            fitContent
            iconName='close'
            type={ButtonType.PRIMARY_LIGHT}
            onClick={clearFilters}
            disabled={!selected.length}
          >
            {t('Clear filters')}
          </Button>
        </li>
      )} */}
    </ul>
  );

  if (isMobile) {
    return (
      <aside className={clsx(styles.filtersContainer, { [styles.isMobile]: isMobile })}>
        <IngredientAccordion
          title={t('Filters')}
          isOpen={openFilters}
          toggleAccordion={() => setOpenFilters((prev) => !prev)}
          isTransparent
        >
          {renderFilters(false)}
        </IngredientAccordion>
      </aside>
    );
  }

  return (
    <aside className={styles.filtersContainer}>
      {renderFilters()}
    </aside>
  );
};

export default Filters;
